import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import { fetchProducts } from '../lib/api';

// Products kept out of this Home section (they stay available everywhere else).
const EXCLUDED_PRODUCT_NAMES = ['Zaya Mangalsutra'];

const ProductShowcase = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    fetchProducts({ isPublished: 'true', limit: 12 }).then((data) => {
      if (isMounted) {
        setProducts(data.filter(p => !EXCLUDED_PRODUCT_NAMES.includes(p.name)).slice(0, 8));
        setLoading(false);
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <section className="py-10 lg:py-12 bg-[#FFFFFF]">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
          <div className="text-left mb-8">
            <h2 className="font-serif text-[24px] text-[#1a1a1a]">Tried and True</h2>
          </div>
          <div className="text-[#7a6a54] text-sm">Loading featured collection...</div>
        </div>
      </section>
    );
  }

  if (!products.length) return null;

  return (
    <section className="py-10 lg:py-12 bg-[#FFFFFF]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="text-left mb-8">
          <h2 className="font-serif text-[24px] text-[#1a1a1a]">Tried and True</h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {products.map(p => (
            <div
              key={p.id}
              className="bg-[#FFFFFF] p-2 sm:p-3 pb-4 shadow-[0_2px_14px_rgba(60,45,20,0.12)] hover:shadow-[0_10px_28px_rgba(60,45,20,0.16)] hover:-translate-y-0.5 transition-all duration-300"
            >
              <ProductCard product={p} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
